import React, {useEffect, useRef} from "react";
import {useSelector} from 'react-redux';
import {Modal, Form} from 'react-bootstrap';
import styled, {keyframes} from 'styled-components';
import axios from "axios";
import t from '../../i18n/translate';
import {baseUrl} from "../../constants/Constant";
import {logPurchase} from "../../services/googleAnalytics";

const LoadingImgContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
  border-radius: 12px;
  z-index: 1;
  pointer-events: none;
`;


const LoadingSpinAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const ModalABACheckoutAnimation = keyframes`
0% { display: none; opacity: 0; } 
100% { display: block; opacity: 1; }
`;

const LoadingImg = styled.img`
  width: 40px;
  position: absolute;
  top: 40%;
  left: 0;
  right: 0;
  margin: auto;
  animation: ${LoadingSpinAnimation} 1s linear infinite;
`;

const PaywayImg = styled.img`
  position: absolute;
  top: -30px;
  right: 0;
  z-index: 100;
`;

const ABACloseBtn = styled.img`
  position: absolute;
  top: 34px;
  right: 24px;
  cursor: pointer;
  z-index: 99999999;
  pointer-events: auto;
`;


const ABACheckoutDesktop = styled.div`
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  z-index: 99999;
  display: block;
  animation-name: ${ModalABACheckoutAnimation};
  animation-duration: 0.5s;
`;

const ABACheckoutContent = styled.div`
  min-height: 264px;
  position: absolute;
  left: 0;
  width: 391px;
  right: 0;
  margin: auto;
  border-radius: 12px;

  .iframe-wrapper {
    height: 400px;
  }

  @media (max-width: 767px) {
    width: 100%;

    .iframe-wrapper {
      height: auto;
    }
  }
`;

const ABAIframe = styled.iframe`
  border-radius: 12px;
  width: 100%;
  max-height: 562px;
  background: #fff;
  border: none;
  transition: height 0.25s;
  position: relative;
  z-index: 2;
  pointer-events: auto;
`;

const ABACheckoutModalContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CheckoutFormABA = (props) => {
	const formRef = useRef(null);
	const cartType = useSelector(state => state.cartReducer.cartType);
	const token = localStorage.getItem('token');
	const _aba_checkout_baseUrl = "https://checkout.payway.com.kh";

	const unlockOrder = async () => {
		props.handleClose();
		if (!token) {
			alert('Please sign in');
			return;
		}

		const type = cartType === 'express' ? 1 : 0;
		const body = {order_id: props.orderId};
		const header = {headers: {Authorization: token}};

		try {
			const verifyRes = await axios.post(`${baseUrl}v1/web/basket/verify/aba?type=${type}`, body, header);
			logPurchase(props.items, props.paymentData);

			if (verifyRes.status === 200 && !verifyRes.data.data.is_paid) {
				const unlockRes = await axios.put(`${baseUrl}v2/web/basket/open?type=${type}`, body, header);
				if (unlockRes.status === 200) {
					props.handleClose(false);
				} else {
					alert('Warning! There is an issue unlocking the order.');
				}
			}
		} catch (err) {
			console.error(err);
			alert('Something went wrong during unlock process');
		}
	};

	const handleClose = () => {
		if (!window.confirm(t('shop_checkout_popup_close_payment', false))) return;

		// Call props.handleClose(false) to close modal
		props.handleClose(false);

		// Then unlock the order
		unlockOrder();
	};


	useEffect(() => {
		const modalContent = document.querySelector('.modal-content');
		if (modalContent) {
			modalContent.style.backgroundColor = "#fff";
			modalContent.style.borderRadius = "5px";
			modalContent.style.width = "100%";
			modalContent.style.maxWidth = "390px";
			modalContent.classList.add('modal-body-wrapper');
			modalContent.classList.remove('modal-content');
		}

		if (props.dialogStatus && props.orderId && props.placeOrderStatus && formRef.current) {
			formRef.current.submit();
		}

		const handleMessage = (e) => {
			const resData = e.data;
			if (resData.close) handleClose();
			if (resData.frameHeight) {
				document.getElementById("aba_webservice").style.height = `${resData.frameHeight}px`;
				const loader = document.getElementById("aba_webservice_loading");
				if (loader) loader.remove();
			}
			if (resData.openApp) {
				window.location = resData.openApp;
			}
		};

		window.addEventListener("message", handleMessage);
		return () => window.removeEventListener("message", handleMessage);
	}, [props.dialogStatus, props.placeOrderStatus]);
	return (
		<Modal
			id="aba_main_modal"
			className="aba-modal"
			show={props.dialogStatus}
			onHide={handleClose}
			aria-labelledby="contained-modal-title-vcenter"
			size="md"
			centered
			backdrop="static"
		>
			<Modal.Body>
				<ABACheckoutDesktop id="aba-checkout">
					<ABACheckoutModalContainer>
						<ABACheckoutContent>
							<LoadingImgContainer id="aba_webservice_loading">
								<LoadingImg src={`${_aba_checkout_baseUrl}/images/loading.svg`}/>
							</LoadingImgContainer>
							<PaywayImg src={`${_aba_checkout_baseUrl}/images/payway-logo-white.svg`}/>
							<ABACloseBtn className='aba-close-button' onClick={() => handleClose()}
							             src={`${_aba_checkout_baseUrl}/images/checkout_cross.svg`}/>
							<div className="iframe-wrapper">
								<ABAIframe name="aba_webservice" id="aba_webservice" height="264" scrolling="yes"/>
							</div>
						</ABACheckoutContent>
					</ABACheckoutModalContainer>
					<Form
						id="aba_merchant_request"
						method="POST"
						target="aba_webservice"
						action={`${baseUrl}api/v2/payment/init`}
						ref={formRef}
					>
						<input type="hidden" name="order_id" value={props.orderId}/>
						<input type="hidden" name="aba_type" value={"abapay"}/>
						<input type="hidden" name="view_type" value="checkout"/>
						<input type="hidden" name="platform" value={props.deviceType}/>
					</Form>
				</ABACheckoutDesktop>
			</Modal.Body>
		</Modal>
	);
};

CheckoutFormABA.defaultProps = {
	dialogStatus: false,
	paymentMethod: null,
	placeOrderStatus: null,
	deviceType: 'desktop',
	handleClose: () => {
	},
	orderId: null,
	items: [],
	paymentData: {},
};

export default CheckoutFormABA;